<template>
  <div>
    <div class="md-layout-item">
      <div class="md-layout">
        <div class="md-layout-item md-size-60">
          <span class="md-display-1"> Tipos </span>
        </div>
        <div class="md-layout-item">
          <router-link
            v-if="$route.query.equipamentoId"
            :to="{
              name: 'EquipamentoCampoEditar',
              params: {
                equipamentoId: $route.query.equipamentoId,
                localId: $route.query.localId,
              },
            }"
          >
            <md-button class="md-primary"> Voltar no equipamento </md-button>
          </router-link>

          <md-button class="md-primary md-raised" @click.stop="openFormCriacao">
            Adicionar tipo
          </md-button>
        </div>
      </div>
      <loading :loading.sync="loadingTable" />
      <md-table v-if="!loadingTable">
        <md-table-row>
          <md-table-head>Nome</md-table-head>
          <md-table-head>Sensores Associados</md-table-head>
          <md-table-head>Prioridade</md-table-head>
          <md-table-head>Tipo Pino</md-table-head>
          <md-table-head>Ação</md-table-head>
          <md-table-head />
        </md-table-row>

        <md-table-row v-for="tipo in tipos" :key="tipo.id">
          <md-table-cell>{{ tipo.tipo }}</md-table-cell>
          <md-table-cell>{{ tipo.quantidadeSensoresAssociado }}</md-table-cell>
          <md-table-cell>{{ tipo.prioridade }}</md-table-cell>
          <md-table-cell>{{
            TipoPinoSensor[tipo.tipoSensorPino]
          }}</md-table-cell>
          <md-table-cell>
            <md-button
              class="md-primary md-raised"
              @click.stop="() => setEdicao(tipo)"
            >
              Editar
            </md-button>
          </md-table-cell>
          <md-table-cell>
            <md-button
              class="md-accent md-raised"
              @click="() => setExcluir(tipo)"
            >
              Excluir
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>

    <md-dialog-confirm
      :md-active.sync="openModalDelete"
      md-title="Deseja deletar esse tipo?"
      md-content="Essa ação não poderá ser desfeita!"
      md-confirm-text="Sim"
      md-cancel-text="Cancelar"
      @md-cancel="onCancelDelete"
      @md-confirm="onConfirmDelete"
    />

    <slider-right ref="slider">
      <div class="container">
        <loading :loading.sync="loadingForm" />
        <br />
        <div v-if="!loadingForm">
          <span class="md-display-1">
            {{ tipoToEdit ? 'Editar' : 'Adicionar' }} sensor
          </span>
          <md-field>
            <label>Nome do sensor</label>
            <md-input v-model="form.tipo" />
          </md-field>

          <md-field>
            <label
              >Tipo de dado (Valor usado para identificar o sensor no
              equipamento)</label
            >
            <md-input v-model.number="form.tipoDado" />
          </md-field>

          <md-switch v-model="form.calibravel">
            Calibrável (permite a calibração do sensor)
          </md-switch>

          <md-field>
            <label
              >Prefixo de Integração (Valor usado para cadastrar sensor)</label
            >
            <md-input v-model.number="form.prefixoIntegracao" />
          </md-field>

          <md-field>
            <label>Prioridade (Usado para ordenar gráficos)</label>
            <md-input v-model.number="form.prioridade" />
          </md-field>

          <md-field>
            <label>Tipo Pino</label>
            <md-select
              v-model.number="form.tipoSensorPino"
              name="tipoSensorPino"
            >
              <md-option
                v-for="(text, id) in TipoPinoSensor"
                :key="id"
                :value="id"
              >
                {{ text }}
              </md-option>
            </md-select>
          </md-field>

          <br />

          <md-button class="md-accent md-raised" @click="fecharSlide">
            Cancelar
          </md-button>
          <md-button class="md-primary md-raised" @click="handleSubmit">
            Salvar
          </md-button>
        </div>
      </div>
    </slider-right>
  </div>
</template>

<script>
import { TipoPinoSensor } from '@/utils/constants'

import Loading from '../../components/Loading'
import SliderRight from '../../components/SliderLeft'
import http from '../../utils/http'

export default {
  name: 'TipoSensorIndex',
  components: { Loading, SliderRight },
  data() {
    return {
      tipos: [],
      tipoToEdit: null,
      tipoToDelete: null,
      loadingTable: true,
      loadingForm: false,
      form: {
        id: null,
        tipo: null,
        tipoDado: -1,
        calibravel: false,
        prefixoIntegracao: '',
        prioridade: 0,
        tipoSensorPino: 0,
      },
    }
  },
  computed: {
    TipoPinoSensor() {
      return TipoPinoSensor
    },
    openModalDelete() {
      return !!this.tipoToDelete
    },
  },
  async mounted() {
    await this.buscarTipos()
  },
  methods: {
    async buscarTipos() {
      this.loadingTable = true
      this.tipos = (await http.get('/tiposSensores')).tiposSensores
      this.loadingTable = false
    },
    onCancelDelete() {
      this.tipoToDelete = null
    },
    async onConfirmDelete() {
      await http.delete('/tiposSensores', this.tipoToDelete.id)

      this.tipoToDelete = null

      await this.buscarTipos()
    },
    setEdicao(tipo) {
      this.tipoToEdit = tipo

      this.form.tipo = tipo.tipo
      this.form.tipoDado = tipo.tipoDado
      this.form.calibravel = tipo.calibravel
      this.form.prefixoIntegracao = tipo.prefixoIntegracao
      this.form.prioridade = tipo.prioridade
      this.form.tipoSensorPino = tipo.tipoSensorPino

      this.$refs.slider.toogleTab()
    },
    setExcluir(tipo) {
      this.tipoToDelete = tipo
    },
    openFormCriacao() {
      this.$refs.slider.toogleTab()
    },
    fecharSlide() {
      this.$refs.slider.close()
    },
    async handleSubmit() {
      let result

      this.loadingForm = true

      if (this.tipoToEdit) {
        result = await http.put('/tiposSensores', {
          id: this.tipoToEdit.id,
          tipo: this.form.tipo,
          tipoDado: this.form.tipoDado,
          calibravel: this.form.calibravel,
          prefixoIntegracao: this.form.prefixoIntegracao,
          prioridade: this.form.prioridade,
          tipoSensorPino: this.form.tipoSensorPino,
        })
      } else {
        result = await http.post('/tiposSensores', {
          tipo: this.form.tipo,
          tipoDado: this.form.tipoDado,
          calibravel: this.form.calibravel,
          prefixoIntegracao: this.form.prefixoIntegracao,
          prioridade: this.form.prioridade,
          tipoSensorPino: this.form.tipoSensorPino,
        })
      }

      this.loadingForm = false

      if (result) {
        this.form.tipo = null
        this.fecharSlide()
        await this.buscarTipos()
      }
    },
  },
}
</script>

<style scoped></style>
